import React, { useEffect } from "react";
import { useSpring, animated } from "react-spring";
import AboutMeCode from "./AboutMeCode";

const About = () => {
  const [isVisible, setVisible] = React.useState(false);
  const [animationComplete, setAnimationComplete] = React.useState(false);

  const springProps = useSpring({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateX(0%)" : "translateX(100%)",
    config: { duration: 1200 },
    onRest: () => {
      setAnimationComplete(true);
    },
  });

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const skillsSection = document.getElementById("about-section");
    const triggerPosition = skillsSection.offsetTop - window.innerHeight / 2;
    setVisible(animationComplete || scrollPosition > triggerPosition);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [animationComplete]);

  return (
    <section
      id="about-section"
      name="about"
      className="flex justify-center items-center w-full h-screen bg-gradient-to-tr from-[#0F172A] to-[#183250] text-slate-50"
    >
      <div className="max-w-[1000px] mx-auto px-6 w-full h-full">
        <animated.p
          style={springProps}
          className="mx-auto mt-32 text-4xl border-b-4 border-yellow-500 sm:text-5xl w-fit"
        >
          About
        </animated.p>
        <div className="flex flex-col gap-x-8 gap-y-10 justify-center items-center mt-10 w-full sm:mt-24 sm:flex-row">
          <p className="text-3xl sm:w-1/2 sm:text-right">
            Hi, I'm Jayant, nice to meet you. Please feel free to look around.
          </p>

          <p className="md:text-[16px] text-justify sm:text-2xl sm:w-2/3 text-yellow-200 w-[380px]">
            <AboutMeCode />
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
